import React, { FC, useCallback } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Formik } from 'formik';

import { useAppDispatch } from '../../../store/hooks';
import { ThunkForgotPassword } from '../../../store/auth/thunks';

import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';

import {
  forgotPasswordFormValidationSchema,
  forgotPasswordInitialValues,
  IForgotPasswordInitialValues,
} from '../form';

import useSharedStyles from '../../../sharedStyles';
import useStyles from './styles'
import { tt } from '@i18n/tt';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const ForgotPasswordDialog: FC<IProps> = ({ open, onClose }) => {
  const dispatch = useAppDispatch();
  const sharedStyles = useSharedStyles();
  const styles = useStyles();

  const handleSubmit = useCallback(
    (values: IForgotPasswordInitialValues) => {
      dispatch(ThunkForgotPassword({ payload: values }))
        .unwrap()
        .then(() => {
          onClose();
        });
    },
    [dispatch, onClose],
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onClick={event => {
        event.stopPropagation();
      }}
      classes={{ paper: styles.content123 }}
    >
      <DialogTitle>{tt('pages.login.forgotPasswordModal.title')}</DialogTitle>
      <DialogContent>
        <span>{tt('pages.login.forgotPasswordModal.field.label')}</span>
        <Formik
          initialValues={forgotPasswordInitialValues}
          onSubmit={handleSubmit}
          validationSchema={forgotPasswordFormValidationSchema}
        >
          {formik => (
            <form onSubmit={formik.handleSubmit}>
              <Input label={tt('pages.login.forgotPasswordModal.field.name')} name="email" formik={formik} />
              <div className={sharedStyles.dialogActions}>
                <Button text={tt('buttons.cancel')} onClick={onClose} />
                <Button text={tt('buttons.submit')} onClick={formik.handleSubmit} />
              </div>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
